import React from "react";
import Header_Banner from "../common-components/common_banner/header_banner/Header_Banner";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";
import { Col, Container, Row } from "react-bootstrap";
import Service_Card from "../common-components/common_card/service_card/Service_Card";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const services = [
    {
      id: 1, // Added ID for navigation
      title: "DG Shipping Approved Medicals",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-1.png",
      description:
        "We provide complete medical examinations for seafarers approved by the Directorate General of Shipping, Mumbai, Ministry of Shipping, Government of India.",
    },
    {
      id: 2,
      title: "Pre-Employment, Periodic & Routine Medicals",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-2.png",
      description:
        "Comprehensive medical assessments to ensure fitness for duty at sea, including: ",
      list: [
        "Detailed medical history review and physical examination",
        "Vision, hearing, and general health assessments",
        "Medical fitness and fit-to-work certification",
      ]
    },
    {
      id: 3,
      title: "Compliance with International Standards",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-3.png",
      description:
        "All medical examinations are conducted in compliance with: ILO Convention 147, MLC 2006, STCW 2010, and the Merchant Shipping (Medical Examination) Rules, 2000, including Amendments 2016.",
    },
    {
      id: 4,
      title: "MMD Medicals",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-4.png",
      description:
        "Medical examinations for COC revalidation, GMDSS, ICDC, STCW courses (new and revalidation), and other certifications required by maritime authorities and institutes. Services include:",
      list: [
        "Issuance and renewal of seafarer medical certificates",
        "Medical fitness assessments for Certificate of Competency (COC) revalidation",
        "Physical examinations as per MMD guidelines",
      ]
    },
    {
      id: 5,
      title: "Pre-Sea Medicals for Maritime Institutes ",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-5.png",
      description:
        "Pre-sea medical examinations to ensure candidates meet the required medical fitness standards before commencing training and a career in the maritime industry. Conducted in accordance with maritime authority guidelines for candidates from reputed maritime institutes.",
    },
    {
      id: 6,
      title: "Post Signed-Off Medicals",
      icon: "/assets/images/services/bottom-img.png",
      hoverImg: "/assets/images/common_service_card/img-6.png",
      description:
        "Post signed-off medical examinations, including hazardous chemical and toxin testing, with reports from NABL/NABH-accredited laboratories.",
    },
  ];

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false }, 
    { label: "SERVICES", link: "", isActive: true },
  ];

  const navigate = useNavigate();

  const handleBlogClick = (id) => {
    navigate(`/services/${id}`);
  };

  return (
    <section className="services">
      <Header_Banner
        imgSrc={"/assets/images/services/13752.png"} // Added leading slash
        title_text="Services"
        breadcrumbs={breadcrumbs}
      />

      <Container className="mt-5">

        <div className="servicetitlediv">
          <h2>DG-Approved Maritime Medical Examinations</h2>
          <p><b>At Shore Clinic</b>, we provide comprehensive <b>DG-Approved marine medical examinations</b> for shore and offshore maritime industry, following DG Shipping and  <b>ILO Convention 147 /MLC 2006 /STCW 2010 / Merchant Shipping (Medical Examination) Rules, 2000& amended Rules 2016</b></p>
          <p>Our team of experts ensures accurate, reliable, and fast medical certification, offering the best care in Pune for all seafarers and maritime professionals.</p>
        </div>
        <Row>
          {services.map((service, index) => (
            <Col lg={4} md={6} sm={12} className="mb-4" key={index}>
              <div className="servcard"
              // onClick={() => handleBlogClick(service.id)}
              >
                <Service_Card {...service} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <Complete_Medical />
    </section>
  );
};

export default Services;